import { GraphConfiguration } from "@/type/common";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import DataBlockItem from "../DataBlockItem";
import AuthContext from "@/store/contexts/AuthContext";
import { loadData } from "@/lib/load-data";
import { refactor_config } from "@/utils/refactor";

const DataBlockItemLoader = ({
  id,
  editing,
}: {
  id: string;
  editing: boolean;
}) => {
  const { configs } = useContext(AuthContext);
  const [config, setConfig] = useState<GraphConfiguration | null>(null);
  const [data, setData] = useState<any[]>([]);
  const loadedConfig = useRef<string | null>(null);

  useEffect(() => {
    const config = configs.find((c) => c.id === id);
    setConfig(config || null);
  }, [id, configs]);

  useEffect(() => {
    if (!config || loadedConfig.current === JSON.stringify(config)) return;
    loadData(refactor_config(config)).then((data) => {
      if (!data || data.length === 0) return;
      const obj = data[0];
      setData(obj[Object.keys(obj)[0]].data || []);
      loadedConfig.current = JSON.stringify(config);
    });
  }, [config]);

  const emptyConfig = useMemo(() => ({} as GraphConfiguration), []);

  return <DataBlockItem config={config || emptyConfig} data={data} />;
};

export default DataBlockItemLoader;
